import React from "react";
import {Box, Grid} from "@mui/material";
import {Competition, FootballMatch} from "../../../../types/eventTypes";
import MatchHighlightFilters
    from "@/pages/custom-components/AggregationComponents/AggregationHeaders/AggregationFilterComponents/MatchHighlightFilters";
import MatchHighlightParams
    from "@/pages/custom-components/AggregationComponents/AggregationHeaders/AggregationParamsComponents/MatchHighlightParams";
import {FilterOption} from "@/types/filterTypes";
import GoalParadeFilters
    from "@/pages/custom-components/AggregationComponents/AggregationHeaders/AggregationFilterComponents/GoalParadeFilters";

interface MatchHighlightHeaderProps{
    matchDay: string
    setMatchDay: (matchDay: string) => void;
    durationMin: number;
    durationMax: number;
    onDurationChange: (type : 'min' | 'max', value: number) => void
    onCompetitionChange: (competition: FilterOption) => void;
    competition: FilterOption | null
    disabled?: boolean
    presetMode?: boolean
}

const GoalParadeHeader: React.FC<MatchHighlightHeaderProps> = ({matchDay, competition, setMatchDay, durationMin, durationMax, onDurationChange, onCompetitionChange, disabled = false, presetMode}) => {
    return (
        <Box sx={{ py: 2 }} data-tour={"goal-parade-header"}>
            <Grid container spacing={2}>
                <Grid size={3}>
                    <GoalParadeFilters
                        disabled={disabled}
                        presetMode={presetMode}
                        competition={competition}
                        matchDay={matchDay}
                        onCompetitionChange={onCompetitionChange}
                        onMatchDayChange={setMatchDay}
                    />
                </Grid>
                <Grid size={9} display={'flex'} alignItems="center" data-tour={"content-aggregation-time-params"}>
                    <MatchHighlightParams
                        durationMin={durationMin}
                        durationMax={durationMax}
                        onDurationChange={onDurationChange}
                    />
                </Grid>
            </Grid>
        </Box>

    )
}

export default GoalParadeHeader;